import { render, staticRenderFns } from "./CartPageDeviceContent.vue?vue&type=template&id=06184372"
import script from "./CartPageDeviceContent.vue?vue&type=script&lang=js"
export * from "./CartPageDeviceContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports